import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";
import { inviteUserToProject } from ".";

export function useInviteUserToProject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.project_members._def,
        mutationFn: inviteUserToProject,
        onSuccess: ()=>{
            queryClient.invalidateQueries({queryKey: queryKeys.project_members._def, exact: false});
        }
    })
}